import {
  GET_CHAT_MESSAGES,
  GET_CHAT_USER_LIST_REQUEST,
  SCROLL_TO_TOP,
  SEND_CHAT_MESSAGE,
  SOCKET_NEW_MESSAGE,
  SOCKET_OFFLINE,
  SOCKET_ONLINE,
  GET_NOTIFICATIONS,
  NEW_NOTIFICATION,
  NOTIFICATION_COUNT,
  READ_MESSAGE, READ_NOTIFICATION,
} from '../actions/rightBar';

import accountHelpers from '../../utils/accountHelpers';

const initialState = {
  chatUserList: [],
  chatUserPage: 1,
  chatUserTotalPage: 1,
  messagesList: [],
  chatTotalPages: 1,
  chatCurrentPage: 1,
  newMessagesCount: 0,
  notificationCurrentPage: 0,
  notificationTotalPage: 0,
  notificationList: [],
  notificationUnreadCount: 0,
  isScrollToTop: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CHAT_USER_LIST_REQUEST.SUCCESS: {
      const { currentPage, pageCount } = payload.data.data._meta;

      const userList = payload.data.data.response.filter(({ id }) => id !== accountHelpers.getUser().id);

      if (currentPage === 1) {
        return {
          ...state,
          chatUserList: userList,
          chatUserPage: currentPage,
          chatUserTotalPage: pageCount,
        };
      }

      return {
        ...state,
        chatUserList: [...state.chatUserList, ...userList],
        chatUserPage: currentPage,
        chatUserTotalPage: pageCount,
      };
    }

    case SOCKET_ONLINE: {
      const newOnlineUserList = state.chatUserList.map((u) => (u.id === payload ? {
        ...u,
        online: true,
      } : u));

      return {
        ...state,
        chatUserList: newOnlineUserList,
      };
    }

    case SOCKET_OFFLINE: {
      const newOfflineUserList = state.chatUserList.users.map((u) => (u.id === payload ? {
        ...u,
        online: false,
      } : u));

      return {
        ...state,
        chatUserList: newOfflineUserList,
      };
    }

    case GET_CHAT_MESSAGES.SUCCESS: {
      return {
        ...state,
        messagesList: [...state.messagesList, ...payload.data.data],
        chatTotalPages: payload.data._meta.pageCount,
        chatCurrentPage: payload.data._meta.currentPage,
      };
    }

    case SEND_CHAT_MESSAGE.REQUEST: {
      return {
        ...state,
        messagesList: [payload, ...state.messagesList],
        isScrollToTop: true,
      };
    }

    case SOCKET_NEW_MESSAGE:
      return {
        ...state,
        newMessagesCount: state.newMessagesCount + 1,
        messagesList: [payload, ...state.messagesList],
        isScrollToTop: true,
      };

    case READ_MESSAGE:
      return {
        ...state,
        newMessagesCount: 0,
      };

    case SCROLL_TO_TOP: {
      return {
        ...state,
        isScrollToTop: payload,
      };
    }

    case GET_NOTIFICATIONS.SUCCESS: {
      return {
        ...state,
        notificationList: [...state.notificationList, ...payload.data.data],
        notificationCurrentPage: payload.data._meta.currentPage,
        notificationTotalPage: payload.data._meta.pageCount,
      };
    }

    case NEW_NOTIFICATION: {
      return {
        ...state,
        notificationList: [payload.data, ...state.notificationList],
        notificationUnreadCount: +state.notificationUnreadCount + 1,
      };
    }

    case READ_NOTIFICATION: {
      return {
        ...state,
        notificationList: state.notificationList.map((n) => (n.noteId === payload ? { ...n, showed: false } : n)),
      };
    }

    case NOTIFICATION_COUNT.SUCCESS: {
      return {
        ...state,
        notificationUnreadCount: payload.data._meta.unreadCount,
      };
    }

    default:
      return state;
  }
};

export default reducer;
